export default "__VITE_ASSET__CDSMIjbZ__"